import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import background from '../../../misc/images/backgrounds/background_10.jpg'
import { ISaleResponse } from '../../../models/Sale'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Sections } from '../../organisms/Sections'
import Breadcrumbs from '../../reusable/Breadcrumbs'
import { Loading } from '../../reusable/Loading'

const SaleScreen = () => {
  const i18n = useRecoilValue(translate).sale
  const breadcrumbs = [
    {
      link: routes.sale,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<ISaleResponse>(URI.getDataUri('/sale', lang))

  return (
    <React.Suspense fallback={<Loading />}>
      <ImageSection id={'sale'} image={background} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        {!!data?.data?.sections.length && <Sections sections={data.data.sections} />}
      </PageWrapper>
    </React.Suspense>
  )
}

export default SaleScreen
